export default "__VITE_ASSET__CBZaggjT__"